import { CheckboxRenderer } from "@/controls/ag-grid/components/CheckboxRenderer";
import { Strand } from "@/pages/caster/data-entry/models/caster.models";
import { dxtToLocalServerTime, getMomentTz } from "@dexteel/mesf-core";
import { ColDef, ColGroupDef, ICellRendererParams } from "ag-grid-enterprise";
const moment = getMomentTz();

export const useTableData = () => {
  const columns: ColGroupDef[] = [
    {
      headerName: "Strands",
      children: [
        {
          field: "Strand",
          headerName: "Strand",
          flex: 2,
          minWidth: 60,
        },
        {
          field: "MoldAndSize",
          headerName: "Mold",
          flex: 2,
          minWidth: 90,
        },
        {
          field: "HeatsOnMold",
          headerName: "Heats On Mold",
          flex: 2,
          minWidth: 100,
        },
        {
          field: "ShroudingMold",
          headerName: "Shrouding Mold",
          flex: 2,
          cellRenderer: CheckboxRenderer,
          minWidth: 110,
        },
        {
          field: "BreakOut",
          headerName: "Break Out",
          flex: 2,
          cellRenderer: CheckboxRenderer,
          minWidth: 80,
        },
        {
          field: "Billets",
          headerName: "Billets",
          flex: 2,
          minWidth: 60,
        },
        {
          field: "IsForSale",
          headerName: "Is For Sale",
          flex: 2,
          cellRenderer: CheckboxRenderer,
          minWidth: 80,
        },
        {
          field: "WaterDeltaTAvg",
          headerName: "Water Delta",
          flex: 2,
          minWidth: 90,
        },
        {
          field: "WaterFlowAvg",
          headerName: "Water Flow",
          flex: 2,
          minWidth: 90,
        },
        {
          field: "WaterTempAvg",
          headerName: "Water Temp",
          flex: 2,
          minWidth: 90,
        },
        {
          field: "FirstCutTime",
          headerName: "First Cut",
          flex: 2,
          minWidth: 80,
          valueGetter: (params: any) => {
            const firstCutTime = params.data.FirstCutTime;
            if (firstCutTime && moment(firstCutTime).isValid()) {
              return dxtToLocalServerTime(firstCutTime, "HH:mm");
            }
          },
        },
        {
          field: "LastCutTime",
          headerName: "Last Cut",
          flex: 2,
          minWidth: 80,
          valueGetter: (params: any) => {
            const lastCutTime = params.data.LastCutTime;
            if (lastCutTime && moment(lastCutTime).isValid()) {
              return dxtToLocalServerTime(lastCutTime, "HH:mm");
            }
          },
        },
        {
          field: "SpeedIPMAvg",
          headerName: "Speed",
          flex: 2,
          minWidth: 60,
          cellRenderer: (params: ICellRendererParams) => {
            const speed = params.value;
            return <span>{speed}</span>;
          },
        },
      ],
    },
  ];

  const defaultColDef: ColDef = {
    filter: false,
    floatingFilter: false,
    sortable: false,
    resizable: false,
    editable: false,
    suppressMovable: true,
  };

  return { columns, defaultColDef };
};
